let loadCounter = 0;
let stockists = new Array();
var map;

var services = ["Click & Collect", "Items in Store", "Pickup in Store", "Delivery"];
var websiteProducts = ["Raised Kennels","Chicken Tractors","Insulated Kennels","Scoop'N'Tow","MultiFeeder"];
var hostname = window.location.hostname.toLowerCase();
var googleMapsAPIKey = "AIzaSyClRLlXRIgyWBlttvGxXwQJ29IxFR157IQ";
if (hostname.includes('kennel'))
{
  websiteProducts = ["Raised Kennels", "Insulated Kennels"];
  googleMapsAPIKey = "AIzaSyDgrYz9gLreDoxsdfAwj8vGZS40xohewEk";
}
else if (hostname.includes('chicken'))
{
  websiteProducts = ["Chicken Tractors"];
  googleMapsAPIKey = "AIzaSyBijv_fK4TFezu_txdHEVHqFFaT9_yNvMQ";
}
  
function Stockist(isStockist, id, franchiseName, name, address, city, state, postcode, phone, lat, lng, url, displayUrl, email, showEmail, showPhone) {
    this.isStockist = isStockist;
    this.id = id;
    this.franchiseName = franchiseName;
    this.name = name;
    this.address = address;
    this.city = city;
    this.state = state;
    this.postcode = postcode;
    this.phone = phone;
    this.lat = parseFloat(lat);
    this.lng = parseFloat(lng);
    this.url = url;
    this.displayUrl = displayUrl;
    this.marker = null;
    this.email = email;
    this.showEmail = showEmail ?? false;
    this.showPhone = showPhone ?? true;
    this.country = '';
    this.servicesOffered = '';
    this.productsOffered = '';
    this.skusForPickup = '';
  
    Stockist.prototype.fromStockist = function (stockist) {
      this.id = stockist.adk_id;
      this.franchiseName = stockist.franchise_name;
      this.name = stockist.store_name;
      this.address = stockist.address_1;
      this.city = stockist.suburb;
      this.state = stockist.state;
      this.postcode = stockist.postcode;
      this.phone = stockist.public_phone_number;
      this.lat = parseFloat(stockist.lat);
      this.lng = parseFloat(stockist.lng);
      this.url = stockist.website_link;
      this.displayUrl = stockist.display_link;
      this.country = stockist.country;
      this.servicesOffered = stockist.services_offered;
      this.productsOffered = this.setProducts(stockist.skus_stocked.split(';'));
      this.isStockist = stockist.status === 'Stockist' && this.stocksWebsiteProducts(websiteProducts);
      this.skusForPickup = this.setSkus(stockist.skus_for_pickup.split(';'));
      return this;
  }

  Stockist.prototype.fromStockistRecord = function (stockist) {
      this.id = stockist.id;
      this.franchiseName = stockist.franchiseName;
      this.name = stockist.name;
      this.address = stockist.address;
      this.city = stockist.city;
      this.state = stockist.state;
      this.postcode = stockist.postcode;
      this.phone = stockist.phone;
      this.lat = stockist.lat;
      this.lng = stockist.lng;
      this.url = stockist.url;
      this.displayUrl = stockist.displayUrl;
      this.country = stockist.country;
      this.servicesOffered = stockist.servicesOffered;
      this.productsOffered = stockist.productsOffered;
      this.isStockist = stockist.isStockist;
      this.skusForPickup = stockist.skusForPickup;
      return this;
  }

  Stockist.prototype.setProducts = function (skusStocked) {
      var products = new Array();
      websiteProducts.forEach((product) => {
          if (skusStocked.includes(product))
            products.push(product);
      });
      return products;
    }
  
    Stockist.prototype.setSkus = function (skusForPickup) {
      var skus = new Array();
      skusForPickup.forEach((sku) => {
          skus.push(sku.replace('*', ''));
      });
      return skus;
    }
  
    Stockist.prototype.stocksWebsiteProducts = function (products) {
      var stocksProducts = false;
      this.productsOffered.forEach((productName) => {
        if (products.includes(productName)) 
            stocksProducts = true;
      });
      return stocksProducts;
    }
  
    Stockist.prototype.getMapContent = function () {
        return this.getContent(false, false);
    }

    Stockist.prototype.getDisplayContent = function () {
        var content = '<td class="location"><a class="lnk" name="' + this.city.replace(' ', '_') + '">' + this.city + '</td>';
        content += '<td class="name"><span class="retailer-name">' + this.name + '</span><br />';
        content += this.address + (this.address.length > 0 ? '<br>' : '') + this.city + (this.state.length > 0 ? ', ' + this.state : '') + (this.postcode.length > 0 ? ', ' + this.postcode : '');
        content += '<div class="phone">Phone: <a href="tel:' + this.phone + '">' + this.phone + '</a></div>';
        if (this.state == "Online" && this.url && this.displayUrl)
            content += '<div class="web">Web: <a target="_blank" href="' + this.url + '" rel="noopener noreferrer">' + this.displayUrl + '</a></div>';
        content += "</td>";
        content += '<td class="products-stocked"><span class="title">Products: </span>' + this.productsOffered.join(', ').replace('Insulated Kennels', 'CozyCube Insulated Dog House') + "</td>";
        /*
        content += '<td class="services-offered"><span class="title">Services Offered: </span>';
        services.forEach((service) => {
            content += '<span class="';
            content += this.servicesOffered.includes(service) ? "service-offered " : "service-not-offered ";
            content += service.toLowerCase().replaceAll(' ', '-').replaceAll('&', '');
            content += '">' + service + "</span>";
        });
        content += '</td>';
        */
        
        content += "<td class='link'>";
        if (this.lat != 0 && this.lng != 0)
            content += '<a class="show_stockist" href="javascript:SelectAndShowStockist(' + this.id + ');" data-id="' + this.id + '">Show on Map</a>';
        content += "</td>";
        return content;
    }

    Stockist.prototype.getDisplayId = function () {
        return "stockist_" + this.id;
    }

    Stockist.prototype.getContent = function (includeUrl, includeMapLink, distance) {
        var content = '<div class="stockist" id="' + this.getDisplayId() + '"><h4>' + this.name;
        if (distance)
            content += " (" + distance + "km)";
        content += '</h4><div class="stockist-address">'
            + this.address + (this.address.length > 0 ? '<br>' : '') + (this.city.length > 0 ? this.city + ', ' : '') + (this.state.length > 0 ? this.state + ', ' : '') + this.postcode + '</div>';

        if ((includeUrl || this.state == "Online") && this.url && this.displayUrl)
            content += '<div class="web"><a target="_blank" href="' + this.url + '" rel="noopener noreferrer">'
                + this.displayUrl + '</a></div>';

        if (this.showPhone)
            content += '<div class="phone">Phone: <a href="tel:' + this.phone + '">' + this.phone + '</a></div>';

        if (this.showEmail)
            content += '<div class="phone">Email: <a href="mailto:' + this.email + '">' + this.email + '</a></div>';

        if (includeMapLink)
            content += '<a class="show_stockist" href="javascript:SelectAndShowStockist(' + this.id + ');" data-id="' + this.id + '">Show on Map</a>';
        content += '</div>';
        return content;
    }

    Stockist.prototype.showWindow = function () {
    }
}

const cachedStockistData = sessionStorage.getItem('stockistData');
if (cachedStockistData) {
    // Stockist data exists in session storage, use it
    const stockistData = JSON.parse(cachedStockistData);
    // console.log('Using cached stockist data:', stockistData);
    
    stockistData.forEach((stockist) => {
        stockists.push(new Stockist().fromStockist(stockist));
    });

  } else {
    // Stockist data doesn't exist in session storage, fetch it
    (async () => {
      const stockistResponse = await fetch('//farmandyard.com.au/apps/postcode/api/stockist/', {
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "skip-browser-warning"
        }
      });
  
      const stockistData = await stockistResponse.json();
      sessionStorage.setItem('stockistData', JSON.stringify(stockistData));
  
    //   console.log('Fetched and cached stockist data:', stockistData);
      
      stockistData.forEach((stockist) => {
        stockists.push(new Stockist().fromStockist(stockist));
      });

    })();
  }

    $('#locate').on('click', async function () {
        var suburb = $('#suburb').val();
        var postcode = $('#postcode').val();
        var sku = $('#current_sku').val();
        var disp = postcode;
        if (suburb != null && suburb.length > 0)
            disp = suburb + ', ' + postcode;

        //   ga('send', {
        //     hitType: 'event',
        //     eventCategory: 'Geo',
        //     eventAction: 'Lookup',
        //     eventLabel: disp
        //   });

        doLookup(false, suburb, postcode, sku, true);

     });


function parseQueryString() {
    var parsedParameters = {},
        uriParameters = location.search.substr(1).split('&');

    for (var i = 0; i < uriParameters.length; i++) {
        var parameter = uriParameters[i].split('=');
        parsedParameters[parameter[0]] = decodeURIComponent(parameter[1]);
    }

    return parsedParameters;
}


function StockistLocation(distance, stockist) {
    this.distance = distance;
    this.stockist = stockist;
}

function sortStockistLocationsByDistance(a, b) {
    return a.distance - b.distance;
}

function sortStockistLocationsByCity(a, b) {
    return a.city > b.city ? 1 : -1;
}

function doLookup(isAdminLookup, suburb, postcode, sku, reset) {
    const country = postcode.toString().length == 5 ? 'us' : 'au';
    const LOCAL_STOCKIST_KEY = 'localStockistData';
    var maxDistance = 500000;
    $('#stockist_notification,#stockist_referral').hide();
    var locality = suburb;
    var storeData = sku != null && sku.length > 0;
    if (reset && storeData)
      localStorage.removeItem(LOCAL_STOCKIST_KEY);
    
    const localStorageData = localStorage.getItem(LOCAL_STOCKIST_KEY);
    if(localStorageData && !reset) {
      console.log("Cached data found!");
      const data = JSON.parse(localStorageData);
      displayResult(data.results, data.adminResults, country, true);
    } else{

      $.getJSON("https://maps.googleapis.com/maps/api/geocode/json?components=locality:" + locality + "|country:" + country + "|postal_code:" + postcode + "&key=" + googleMapsAPIKey, function (response) {
          var adminResults = [];
          var results = [];


          if (response.status == "OK" && response.results.length > 0) {
              for (var i = 0; i < response.results.length; i++) {
                  var result = response.results[i];
                  for (var j = 0; j < result.address_components.length; j++) {
                      for (var m = 0; m < result.address_components[j].types.length; m++) {
                          var type = result.address_components[j].types[m];
                          if (type == "postal_code" && result.address_components[j].short_name == postcode) {
                              var latLon = result.geometry.location;
                              for (var k = 0; k < stockists.length; k++) {
                                  var stockist = stockists[k];
                                  var skuMatch = !sku;
                                  if (sku)
                                  {
                                    for (var l = 0; l < stockist.skusForPickup.length; l++)
                                    {
                                      var skuForPickup = stockist.skusForPickup[l];
                                      if (skuForPickup.length > 0 && sku.startsWith(skuForPickup))
                                      {
                                          skuMatch = true;
                                          break;
                                      }
                                    }
                                  }
                                  if (skuMatch)
                                  {
                                    var distance = getDistance(latLon.lat, latLon.lng, stockist.lat, stockist.lng);
                                    if (stockist.isStockist) {
                                        if (distance < maxDistance)
                                            results.push(new StockistLocation(distance, stockist));
    
                                    } else if (isAdminLookup && distance < 100000) {
                                        adminResults.push(new StockistLocation(distance, stockist));
                                    }
                                  }
                              }
                          }
                      }
                  }
              }
          }
          
          if (storeData)
          {
            // Update data in localStorage
            const dataToStore = { results, adminResults };
            localStorage.setItem(LOCAL_STOCKIST_KEY, JSON.stringify(dataToStore));
          }

          displayResult(results, adminResults, country);
      }).fail(function () {
          console.log("error");
      });
    }

    function displayResult(results, adminResults, country, convertToStockist) {
      $('#geo_result').show();

      if (isAdminLookup) {
          $('#geo_stockist_nonconfirmed').html('');
      }

      $('.postcode').html(postcode);
      $('#delivery_yes, #delivery_no, #delivery .instruction').hide();
      isFlatRatePostcode(postcode) ? $('#delivery_yes, #delivery .instruction').show() : $('#delivery_no').show();

      results.sort(sortStockistLocationsByDistance);
      if (results.length === 0) {
          // No results, show Delivery tab as default
          $('.tab-content#delivery').show();
          $('.tab-link[data-tab="delivery"]').addClass('active');
          // For US
          $('#pickup .us-in-stock-item').hide();
          $('#pickup .ask-products').show();
          $('#pickup .available-pickup-details').hide();
          $('#pickup .coming-soon-pickup').show();

          $('#geo_stockist').html("Sorry, we couldn't find any retailers near your location. Check back soon for more <a href='/pages/retail-store-finder' style='text-decoration: underline;'>retail locations</a>");

          if (country === 'us') {
              $('.delivery-pickup-tab #postcode_locate').hide();
          }
      } else {
          // With results, show Pick Up tab as default
          $('.tab-content#pickup').show();
          $('.tab-link[data-tab="pickup"]').addClass('active');
          // For US
          $('#pickup .us-in-stock-item').show();
          $('#pickup .ask-products').hide();
          $('#pickup .available-pickup-details').show();
          $('#pickup .coming-soon-pickup').hide();

          if (country === 'us') {
              $('.delivery-pickup-tab #postcode_locate').show();
          }
        
          $('#geo_stockist').html('');
          for (let i = 0; i < Math.min(results.length, 3); i++) {
              var item = convertToStockist ? new Stockist().fromStockistRecord(results[i].stockist) : results[i].stockist;
              $('#geo_stockist').append(item.getContent(false, !isAdminLookup, isAdminLookup ? Math.round(results[i].distance / 1000, 0) : 0));
          }
      }

      if (isAdminLookup) {
          adminResults.sort(sortStockistLocationsByDistance);
          for (let i = 0; i < adminResults.length; i++) {
            var item = convertToStockist ? new Stockist().fromStockistRecord(adminResults[i].stockist) : adminResults[i].stockist;
            $('#geo_stockist_nonconfirmed').append(item.getContent(false, false, Math.round(adminResults[i].distance / 1000, 0)));
          }
      } else if (results[0].distance > 50000) {
          $('#stockist_notification, #stockist_referral').show();
      }
  }
}

function getDistance(lat1, lng1, lat2, lng2) {
    var lat = [lat1, lat2]
    var lng = [lng1, lng2]
    var R = 6378137;
    var dLat = (lat[1] - lat[0]) * Math.PI / 180;
    var dLng = (lng[1] - lng[0]) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat[0] * Math.PI / 180) * Math.cos(lat[1] * Math.PI / 180) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return Math.round(d);
}


function PostcodeRange(from, to) {
    this.from = from;
    this.to = to;
}

function isFlatRatePostcode(postcode) {
    var postcodes = [];
    //postcodes.push(new PostcodeRange(6200, 6799));
    postcodes.push(new PostcodeRange(0802, 0803));
    postcodes.push(new PostcodeRange(0805, 0809));
    postcodes.push(new PostcodeRange(0815, 0819));
    postcodes.push(new PostcodeRange(0822, 0827));
    postcodes.push(new PostcodeRange(0833, 0834));
    postcodes.push(new PostcodeRange(0839, 0899));
    postcodes.push(new PostcodeRange(0802, 0803));
    // postcodes.push(new PostcodeRange(4492, 4492));
    ///  postcodes.push(new PostcodeRange(4800, 4999));
    // postcodes.push(new PostcodeRange(4680, 4680));
    //  postcodes.push(new PostcodeRange(6200, 6999));

    for (var i = 0; i < postcodes.length; i++) {
        if (postcode >= postcodes[i].from && postcode <= postcodes[i].to)
            return false;

    }
    return true;
}


/* Map-specific functionality */

// Callback method called once Google Maps API is loaded. 
async function initMapData(city, state) {
    console.log("waiting for stockists");
    while((typeof stockists === 'undefined' || stockists?.length == 0) && loadCounter < 10) {// define the condition as you like
        loadCounter++;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    // console.log("stockists is defined", stockists);

    if (typeof stockists === 'undefined' || stockists?.length == 0) {
        // stockists = await getStockists();
        console.log('Map error: No Stockists Found')
    } else {
        initMap(city, state);
    }
}

// Initialize and add the map
function initMap(city, state) {
    var country = $('#stockist_map').data('country');
    country = country.replace(/\s/g, '');
    console.log('country', country);
    if (country === "AUD") {
        map = new google.maps.Map(document.getElementById("stockist_map"), {
        zoom: 3.7,
        center: { lat: -28.0363, lng: 133.5 }
        });
    } else {
        map = new google.maps.Map(document.getElementById("stockist_map"), {
        zoom: 3.7,
        center: { lat: 39.50, lng: -98.35 }
        });
    }
    let states = {};
    let stateCodes = [
      'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
      'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
      'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
      'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
      'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
    ];
    const provinceCodes = [
      'NSW', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'ACT', 'NT', 'Online'
    ];
    
    var $stockistList = $('#stockist_list');
    var ausCount = 0;
    var usCount = 0;
  
    for (var i = 0; i < stockists.length; i++)
    {
      var stockist = stockists[i];
      if (stockist.isStockist && (state == null || stockist.state == state) && (city == null || stockist.city == city))
      {
        if (provinceCodes.includes(stockist.state) || stateCodes.includes(stockist.state))
        {
          var stateList = states[stockist.state];
          if (stateList == null)
          {
            stateList = new Array();
            states[stockist.state] = stateList;
          }
          stateList.push(stockist);
          if (stockist.country == 'Australia')
            ausCount++;
          if (stockist.country == 'USA')
            usCount++;
          
          if (stockist.lat != 0 && stockist.lng != 0)
          {  stockist.marker = new google.maps.Marker({
              position:  { lat: stockist.lat, lng: stockist.lng },
              map: map,
            });
            stockist.marker.infowindow = new google.maps.InfoWindow({
              content: stockist.getMapContent(),
            });
    
            google.maps.event.addListener(stockist.marker, "click", function() {
              ShowStockist(this);
            });
          }
        }
      }
    }

    // set counts
    $('#stockist-count-au').html(ausCount);
    //$('#stockist-count-us').html(usCount);
  
    var table = "<table class='stockist_table'>"
    table += "<thead>";
    table += "	<tr>";
    table += " 		<th class='location'>Location</th>";
    table += " 		<th class='name'>Retailer</th>";
    table += " 		<th class='products'>Products</th>";
    //table += " 		<th class='product-availability'>Availability</th>";
    table += " 		<th class='link'>Map Link</th>";
    table += " 	</tr>";
    table += "</table>";
  
    $stockistList.append(table);
    $table = $('.stockist_table');
    let index = 0;
    for (var stateKey in states)
    {
      var stateList = states[stateKey];
      
      if (provinceCodes.includes(stateKey) || stateKey.length > 2) { 
          table = '<tr class="state AUD">';
      }  else if (stateCodes.includes(stateKey)) {
        table = '<tr class="state USD">';
      }
      table += '<td colspan="4"><h3>' + stateKey + '</h3></td>';
      table += '</tr>';
  
      stateList.sort(sortStockistLocationsByCity);
      for (var i = 0; i < stateList.length; i++)
      {
        let countryCode = stateList[i].state;

        if (provinceCodes.includes(countryCode) || countryCode.length > 2) {
            table += '<tr class="stockist AUD" id="' + stockist.getDisplayId() + '">';
        } else if (stateCodes.includes(countryCode) && countryCode.length === 2) {
            table += '<tr class="stockist USD" id="' + stockist.getDisplayId() + '">';
        }
        table += stateList[i].getDisplayContent();
        table += '</tr>';
      }
      $table.append(table);
      index++;
    }
    
    if($(window).width() < 800) {
      map.setZoom(3.2);
    }
}

function SelectAndShowStockist(id)
{
  for (var i = 0; i < stockists.length; i++)
  {
    if (stockists[i].id == id)
    {
      ShowStockist(stockists[i].marker, 14);
      break;
    }
  }
  console.log('top: ' + $('#stockist_map').position().top);
  $("html, body").animate({ scrollTop: $('#stockist_map').position().top + 150 }, "slow");
  return false;
}

function ShowStockist(marker, zoom)
{
  for (var i = 0; i < stockists.length; i++)
  {
    if (stockists[i].marker != null)
      stockists[i].marker.infowindow.close();
  }
  marker.infowindow.open(map, marker);
  if (zoom)
  {
    map.setZoom(zoom);
    var latLng = marker.getPosition();
    map.setCenter(latLng);
  }
}

    
  function LoadDefaultPostcode(){
    const postalCode = localStorage.getItem('postalCode');
    if (postalCode == null) {
      $.get("https://ipinfo.io", function(response) {
        //console.log("Your IP Address: " + response.ip);

        var loc = response.loc.split(",");
        var lat = loc[0];
        var lng = loc[1];
        
        //console.log("Latitude: " + lat);
        //console.log("Longitude: " + lng);

        var geocodingUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${googleMapsAPIKey}`;

        $.get(geocodingUrl, function(geocodingResponse) {
          console.log(geocodingResponse.results);
          if (geocodingResponse.results.length > 0) {
              let postcode = null;
          
              for (let i = 0; i < geocodingResponse.results.length; i++) {
                  const addressComponents = geocodingResponse.results[i].address_components;
                  postcode = addressComponents.find(component => component.types.includes("postal_code"));
          
                  if (postcode) {
                      break; // Exit the loop when a postal code is found
                  }
              }
          
              if (postcode) {
                  //console.log("Your Postcode: " + postcode.short_name);
                  localStorage.setItem('postalCode', postcode.short_name);
              } else {
                  //console.log("Postcode not found.");
              }
          } else {
              //console.log("Location not found.");
          }
        });
      }, "jsonp");
    }
  }


$(document).ready(async function () {
    //initDisplay();

    var searchParams = parseQueryString();
    var postcode = searchParams["postcode"];
    if (postcode != null) {
        $('#postcode').val(postcode);
        doLookup(location.href.indexOf('lookup') > -1, null, postcode);
    }

    $('a[href="#product"]').on('click', function(){
      $([document.documentElement, document.body]).animate({
          scrollTop: $("a[name='product']").offset().top - 50
      }, 750);
    });

  if(window.location.pathname.includes('/products/')) {
    //console.log("Product page");
    const postalCode = localStorage.getItem('postalCode');
   if(postalCode != null) {
      $('#postalcode').html(postalCode);
      $('#postcode').val(postalCode);

      // only auto populate if the postcode locate exists
      var sku = $('#current_sku').val();
      if (sku != null && sku.length > 0)
          doLookup(false, null, postalCode, sku);
    } else {
      //LoadDefaultPostcode();
      $('#postalcode').html('Location not set');
      $('.change-postcode').text('Set Location');
      // No location set, show Delivery tab as default
      $('.tab-content#delivery').show();
      $('.tab-link[data-tab="delivery"]').addClass('active');
    }
  }
});



/*
function getTimeRemaining(endtime) {
    const total = Date.parse(endtime) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));

    return {
      total,
      days,
      hours,
      minutes,
      seconds
    };
  }

  function initializeClock(id, endtime) {
    const clock = document.getElementById(id);
    if (clock)
    {
      const daysSpan = clock.querySelector('.days');
      const hoursSpan = clock.querySelector('.hours');
      const minutesSpan = clock.querySelector('.minutes');
      const secondsSpan = clock.querySelector('.seconds');
  
      function updateClock() {
        const t = getTimeRemaining(endtime);
  
        daysSpan.innerHTML = t.days;
        hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
        minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
        secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
  
        if (t.total <= 0) {
          clearInterval(timeinterval);
        }
      }
  
      updateClock();
      const timeinterval = setInterval(updateClock, 1000);
    }
  }

  const deadline = new Date(2023, 5, 30, 23, 59, 59);

  initializeClock('clockdiv', deadline);
*/
